import React          from 'react';
import colors         from '../utils/colors';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
    root: {
        position:        'fixed',
        top:             0,
        left:            0,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        minHeight:       '100vh',
        minWidth:        '100vw',
        maxHeight:       '100vh',
        maxWidth:        '100vw',
        backgroundColor: 'rgba(0,0,0,0.5)',
        transition:      'all 0.7s'
    },
    container: {
        width:           '50vw',
        height:          '50vh',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        flexFlow:        'column',
        borderRadius:    '0.5em',
        backgroundColor: '#FFF'
    },
    text: {
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        textAlign:       'center',
        fontSize:        25
    },
    button: {
        height:          40,
        width:           100,
        marginTop:       40,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        textAlign:       'center',
        color:           '#FFF',
        borderRadius:    '0.5em',
        backgroundColor: colors.dark,
        cursor:          'pointer'
    }
}))

type ErrorModalProps = {
  showCodeErrorModal: boolean;
  handleClick:        () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({
    showCodeErrorModal,
    handleClick,
}) => {

  const classes = useStyles();

  return (
   
        <div 
          className = { classes.root }
          style     = {{
            opacity:   showCodeErrorModal ? 1 : 0,
            transform: `translate(0px, ${ showCodeErrorModal ? 0 : 200 }vh)`
          }}
        >
          <div className = { classes.container }>
                <div
                    dir       = 'rt'
                    className = { classes.text }
                >
                    { `קוד המורה שהזנת שגוי` }
                </div>
                <div 
                    dir       = 'rt'
                    className = { classes.button }
                    onClick   = { handleClick }
                >
                    { `סגור` }
                </div>
           </div>
        </div>
  );
}


export default ErrorModal;


